<template>
  <div class="p-4">
    <b-card-group deck>
      <b-card
        v-for="o in options"
        :key="o.id"
        :class="{ 'is-active': active === o.id }"
        @click="update(o.id)"
        bg-variant="lightblack"
        text-variant="white"
        class="text-center cursor-pointer"
      >
        <b-card-text>
          {{ o.name }}
        </b-card-text>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import { BCardGroup, BCard, BCardText } from "bootstrap-vue";

export default {
  name: "SelectSingle",
  components: { BCardGroup, BCard, BCardText },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    active: null,
  }),
  methods: {
    update(value) {
      this.active = value;
      this.$emit("update", value);
    },
  },
};
</script>

<style scoped>
.is-active {
  background-color: #ac9466 !important;
  font-weight: bold;
}
</style>
